import { expVal } from '@atlassian/jira-feature-experiments';

const JiraSoftwareTimelineHierarchyViewSettingsRelayProvider = {
	get(): boolean {
		return expVal('jira_software_timeline_hierarchy_view_settings', 'isEnabled', false);
	},
};

export default JiraSoftwareTimelineHierarchyViewSettingsRelayProvider;
